import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Stepper(theme: Theme): Components<Theme> {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
  };
}
